export default __webpack_public_path__ + "./images/nu.f9947867.png";